
import { Link } from "react-router-dom";
import List from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Table } from "react-bootstrap";
import { useState } from "react";
import SearchBoxModal from "../component/SearchBoxModal";
import { confirmAlert } from "react-confirm-alert";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { useSelector } from "react-redux";
import Loading from "../component/Loading";

export default function DanhSachPhanLoai() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState();
    const [filterShow, setFilterShow] = useState(false)
    const [title, setTitle] = useState("")
    const [department_id, setDepartment_Id] = useState();
     const [loading, setLoading] = useState(false);

    const columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề", options: { filter: true, sort: true } },
        {
            name: "list_step", label: "Tiến trình",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="w-100 wf-progress">
                        {value.map((item, i) => {
                            let progress = JSON.parse(item.departments)
                            return <div className="mr-2 item" key={item.id}>
                                <div className="btn btn-outline-primary  main">{i + 1}. {item.title}</div>
                                <div className="info">
                                    <div className="wrapper rounded shaddow">
                                        {progress &&
                                            <Table striped bordered hover className="table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>STT</th>
                                                        <th>Tên Phòng|Ban</th>
                                                        <th>Người ký phụ</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {progress.map((item, i) => {
                                                        return <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>
                                                                <p>{item.department_label}</p>
                                                                {item.user_label ? <p>Ký chính: {item.user_label}</p> : null}
                                                            </td>
                                                            <td>{item.kyphu == 0 ? "Không" : "Có"}</td>

                                                        </tr>
                                                    })}
                                                </tbody>
                                            </Table>
                                        }
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                },
            }
        },
        {
            name: "departments", label: "Phòng ban sử dụng", options: {
                filter: false, sort: true,
                customBodyRender: (departments, tableMeta, updateValue) => {
                    if (departments && departments.length > 0) {
                        return departments.map((item, k) => {
                            return <div className="btn btn-sm btn-outline-success mb-2" key={item.id}>{item.title}</div>
                        })
                    }
                    return "Sử dụng chung"
                }
            }
        },
        {
            name: "author_name", label: "Người tạo", options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="w-100">
                        <span>{value}</span><br />
                        <button type="button" className="btn btn-sm btn-info text-white" onClick={() => onCloneType(tableMeta.id)}><i className="fas fa-paste"></i> Sao chép</button>
                    </div>
                }
            }
        },
        { name: "datecreate", label: "Ngày tạo", }
    ];

    const onCloneType = (id) => {
        confirmAlert({
            title: 'Cảnh báo',
            message: "Bạn muốn sao chép loại tờ trình này ?",
            buttons: [
                {
                    label: 'OK', onClick: () => {
                        setLoading(true)
                        Axios.get(URL_LIST_ALL + "crm_workfollow_clone/" + id, user.config).then((res) => {
                            setLoading(false)
                            if (res.data.status === "success") {
                                window.location.href = "/edit-workflow_type/" + res.data.data.id
                            } else {
                                alert(res.data.message)
                            }
                        }).catch((e) => console.log(e));
                    }
                },
                {
                    label: 'Hủy', onClick: () => {

                    }
                },
            ]
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (title && title !== '') _param += "&title=" + title
        if (department_id && department_id !== '') _param += "&part_id=" + department_id
        setParam(_param);
    };


    return (<AkkhorLayout idrole="workflow_type">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Phân loại
                </li>
            </ul>
        </div>
        {loading && (<Loading />)}
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-3 col-12 form-group">
                            <label>Tiêu đề</label>
                            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control form-control-sm height32" />
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Phòng ban </label>
                            <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} name='department_id'
                                onChange={(e) => {
                                    setDepartment_Id(e)
                                }}></SearchBoxModal>
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <List name="crm_workflow_type" idrole="workflow_type" linkaction="workflow_type" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
